module.exports = __webpack_public_path__ + "img/sv47.de48bdbe.svg";